<template>
    <div class="scratchWorksPlay">
        <div class="works-ralative">
            <div v-if="scratchLoading" class="worksLoading">
                <img :src="themeData.logo" alt="">
                <div class="scratch-loading">
                    <div class="filled" :style="`width: ${width}%`"></div>
                </div>
            </div>
            <div id="scratch-player"></div>
        </div>
        <div class="panel-container f-cb" v-show="keyboard != 1">
            <div class="keyboardBox" v-if="keyboard == 2">
                <div class="sxzu-bar-one">
                    <div class="key left arrow-left" id="mleftBtn"></div> 
                    <div class="key down arrow-down" id="mdownBtn"></div> 
                    <div class="key right arrow-right" id="mrightBtn"></div> 
                    <div class="key up arrow-up" id="mupBtn"></div>
                </div> 
                <div class="space f-fr" id="mspaceBtn"></div>
                <div class="q" id="mqBtn">Q</div>
                <div class="w" id="mwBtn">W</div>
                <div class="e" id="meBtn">E</div>
            </div>
            <div class="keyboardBox" v-if="keyboard == 3">
                <div class="sxzu-bar">
                    <div class="key left arrow-left" id="mleftBtn"></div> 
                    <div class="key down arrow-down" id="mdownBtn"></div> 
                    <div class="key right arrow-right" id="mrightBtn"></div> 
                    <div class="key up arrow-up" id="mupBtn"></div>
                </div> 
                <div class="sxzu-bar-wasd">
                    <div class="key keyW arrow-w" id="mwBtn">W</div> 
                    <div class="key keyA arrow-a" id="maBtn">A</div> 
                    <div class="key keyS arrow-s" id="msBtn">S</div> 
                    <div class="key keyD arrow-d" id="mdBtn">D</div>
                </div> 
            </div>
            <div class="keyboardBox" v-if="keyboard == 4">
                <div class="num-keypad">
                    <div class="key number" id="m7Btn">7</div>
                    <div class="key number" id="m8Btn">8</div>
                    <div class="key number" id="m9Btn">9</div>
                    <div class="key number" id="m4Btn">4</div>
                    <div class="key number" id="m5Btn">5</div>
                    <div class="key number" id="m6Btn">6</div>
                    <div class="key number" id="m1Btn">1</div>
                    <div class="key number" id="m2Btn">2</div>
                    <div class="key number" id="m3Btn">3</div>
                </div>
            </div>
            <div class="playGame" id="playGame">开始</div>
            <div class="stopGame" id="stopGame">结束</div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        themeData() {
            return this.$store.state.themeData;
        }
    },
    data() {
        return {
            worksId: "",
            scratchLoading: true,
            keyboard: 0,
            width: 0,
            interval: null
        }
    },
    created() {
        this.getWorksId();
    },
    mounted() {
        this.getScratchJS();
    },
    beforeRouteLeave (to, from, next) {
        document.getElementById('stopGame').click();
        next();
    },
    methods: {
        //获取worksId
        getWorksId() {
            if(this.$route.params.id) {
                this.worksId = this.$route.params.id;
            } else {
                let arr = location.href.split('?');
                this.worksId = arr[0].slice(location.href.lastIndexOf('/') + 1)
            }
        },
        //加载scratch
        getScratchJS() {
            this.width += 15;
            const oScript1 = document.createElement('script');
            oScript1.type = 'text/javascript';
            oScript1.src = 'https://static-highcoding.oss-cn-zhangjiakou.aliyuncs.com/player/compatibility.js';
            document.body.appendChild(oScript1);
            this.width += 25;
            const oScript2 = document.createElement('script');
            this.width += 5;
            oScript2.type = 'text/javascript';
            oScript2.src = 'https://scratch-highcoding.oss-accelerate.aliyuncs.com/lib/community/lib.min.js';
            this.width += 5;
            oScript2.onload = () => {
                clearInterval(this.interval);
                this.width = 88;
                setTimeout(() => {
                    this.width = 95;
				}, 1500)
                setTimeout(() => {
                    this.width = 99;
					this.scratchLoading = false;
				}, 3000)
            }
            document.body.appendChild(oScript2);
        },
    }
}
</script>
<style scoped>
.works-ralative {
    position: relative;
    width: 750px;
    height: 585px;
    line-height: 15px;
}
.worksLoading {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: var(--theme-color);
    z-index: 999;
}
.worksLoading img {
    max-width: 300px;
    max-height: 35%;
}
.scratch-loading{
    width: 80%;
    height: 50px;
    margin-top: 5rem;
    background-color: #e6e6e6;
    border: 5px solid #fff;
    border-radius: 25px;
    box-shadow: 0 12px 5px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    overflow: hidden;
}
.scratch-loading .filled{
    height: 100%;
    width: 0%;
    border-radius: 25px;
    background-color: var(--theme-color);
}
.panel-container {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/scratchWorksPlay/scratchWorksPlay.vue